












































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { UserPromotionListEntry } from "@/types";
import { RankIcon } from "@/types/DiscordUserInterface";
import Discord from "@/Discord";

@Component({
  metaInfo: {
    title: "Badge Management – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "Manage badge unlocks for Newfound Pioneer Corps members." },
      { vmid: "og:title", property: "og:title", content: "Badge Management – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "Manage badge unlocks for Newfound Pioneer Corps members." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/badge-management" },
    ],
  },
})
export default class IconManagement extends Vue {
  public users: UserPromotionListEntry[] = [];
  public allIcons: RankIcon[] = [];
  public selectedUser: UserPromotionListEntry | null = null;
  public unlockedIconIds: number[] = [];
  public loadingUsers: boolean = false;
  public loadingUserIcons: boolean = false;
  public saving: boolean = false;

  public async mounted() {
    this.loadingUsers = true;
    try {
      const [usersRes, iconsRes] = await Promise.all([
        this.axios.get("/users/userPromotionMessages"),
        this.axios.get("/users/icons"),
      ]);
      this.users = usersRes.data;
      this.allIcons = iconsRes.data;
    } catch {
      this.$store.dispatch("showErrorSnackbar", "Failed to load data.");
    } finally {
      this.loadingUsers = false;
    }
  }

  public getUserLabel(user: UserPromotionListEntry): string {
    return user.name;
  }

  public getAvatarUrl(id: string, avatar: string): string {
    return Discord.avatarSourceUri(id, avatar);
  }

  public getIconUrl(filename: string): string {
    try {
      return require(`@/assets/images/icons/${filename}.svg`);
    } catch {
      return "";
    }
  }

  public formatFilename(filename: string): string {
    return filename
      .replace(/^rank_/, "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  public isUnlocked(icon: RankIcon): boolean {
    return this.unlockedIconIds.indexOf(icon.id) !== -1;
  }

  public toggleIcon(icon: RankIcon): void {
    const idx = this.unlockedIconIds.indexOf(icon.id);
    if (idx === -1) {
      this.unlockedIconIds.push(icon.id);
    } else {
      this.unlockedIconIds.splice(idx, 1);
    }
  }

  public async saveIcons(): Promise<void> {
    if (!this.selectedUser) { return; }
    this.saving = true;
    try {
      await this.axios.patch(`/users/discordUsers/${this.selectedUser.id}`, {
        unlockedIcons: this.unlockedIconIds,
      });
    } catch {
      this.$store.dispatch("showErrorSnackbar", "Failed to save badges.");
    } finally {
      this.saving = false;
    }
  }

  @Watch("selectedUser")
  private onSelectedUserChanged(user: UserPromotionListEntry | null): void {
    if (user) {
      this.loadUserIcons(user.id);
    } else {
      this.unlockedIconIds = [];
    }
  }

  private async loadUserIcons(userId: string): Promise<void> {
    this.loadingUserIcons = true;
    this.unlockedIconIds = [];
    try {
      const res = await this.axios.get(`/users/discordUsers/${userId}`);
      const icons: RankIcon[] = res.data.unlockedIcons || [];
      this.unlockedIconIds = icons.map((i) => i.id);
    } catch {
      // If endpoint doesn't return icon data, start with empty selection
    } finally {
      this.loadingUserIcons = false;
    }
  }
}
